import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "empty-state"
}

import { translate } from '@hotwax/dxp-components';
import {
  IonBadge,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonTitle,
  IonToolbar,
  modalController,
} from "@ionic/vue";
import { closeOutline } from "ionicons/icons";
import { computed, onMounted, ref } from "vue";
import { getDate, getTime, timeTillRun, hasError } from "@/utils";
import { useStore } from "vuex";
import { RuleService } from "@/services/RuleService";
import logger from "@/logger";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'RuleGroupHistoryModal',
  setup(__props) {

const router = useRouter();
const store = useStore();
const ruleGroup = computed(() => store.getters["rule/getRuleGroup"]);

let groupHistory = ref([]) as any

onMounted(async () => {
  await fetchGroupHistory()
})

async function fetchGroupHistory() {
  groupHistory.value = []

  if(!ruleGroup.value?.jobName) {
    return;
  }

  try {
    const resp = await RuleService.fetchRuleGroupHistory({ jobName: ruleGroup.value.jobName, pageSize: 20, orderByField: "lastUpdatedStamp DESC" })

    if(!hasError(resp)) {
      // Sorting the history based on startTime, as we does not get the records in sorted order from api
      groupHistory.value = resp.data.sort((a: any, b: any) => b.startTime - a.startTime)
    } else {
      throw resp.data;
    }
  } catch(err) {
    logger.error(err)
  }
}

function closeModal() {
  modalController.dismiss();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Execution history")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        (_unref(groupHistory).length)
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupHistory), (history) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: history.jobRunId
                  }, [
                    (history.startTime)
                      ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(_unref(getTime)(history.startTime)), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(getDate)(history.startTime)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (history.endTime)
                              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                  key: 0,
                                  color: "dark"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(timeTillRun)(history.endTime)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(_unref(translate)("No available history for rule.", { name: _unref(router).currentRoute.value.name?.toString().toLowerCase() })), 1)
            ]))
      ]),
      _: 1
    })
  ], 64))
}
}

})